import React from 'react';
import { Dialog } from '@material-ui/core';
import Button from 'components/Button';
import useStyles from './referAndEarnPopup.styles';
import { useTranslation } from 'react-i18next';
import Icon, { IconsType } from 'components/Icon';
import Typography from 'components/Typography';
import { ReferAndEarnPopupProps, mapStateToProps, mapDispatchToProps } from './referAndEarnPopup.scheme';
import { connect } from 'react-redux';
import { useTheme } from '@material-ui/core';

const ReferAndEarnPopup: React.FunctionComponent<ReferAndEarnPopupProps> = (props) => {
    const { open, onClose } = props;

    const classes = useStyles();
    const { t } = useTranslation('common');
    const theme = useTheme();

    const iconShow = React.useMemo(() => {
        return theme.palette.type === 'dark' ? IconsType.refer_and_earn_alert_dark : IconsType.alert_circle_with_bg;
    }, [theme.palette.type]);

    const { paper, root } = React.useMemo(
        () => ({
            paper: classes.dialogPaper,
            root: classes.backDrop,
        }),
        [classes.dialogPaper, classes.backDrop]
    );

    return (
        <Dialog onClose={onClose} open={open} classes={{ paper, root }}>
            <div className={classes.contentContainer}>
                <div className={classes.closeButtonWrapper}>
                    <Button onClick={onClose} className={classes.closeButton} variant="text">
                        <Icon name={IconsType.close_piqk} />
                    </Button>
                </div>
                <div className={classes.iconWrapper}>
                    <Icon name={iconShow} />
                </div>

                <Typography className={classes.header} variant="tXlSemibold">
                    {t('referAndEarnPopup.title')}
                </Typography>
                <Typography className={classes.subTxt} variant="tLgMedium">
                    {t('referAndEarnPopup.description')}
                </Typography>

                <Button
                    color={'primary'}
                    fullWidth
                    variant="contained"
                    onClick={onClose}
                    className={classes.uploadButton}
                >
                    {t('referAndEarnPopup.close')}
                </Button>
            </div>
        </Dialog>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(ReferAndEarnPopup));
